export default (url) => ({
  service: 'execute-api',
  region: 'eu-west-2',
  host: process.env.VUE_APP_API_HOST,
  url,
  path: url.split(process.env.VUE_APP_API_HOST)[1],
});
